import { initializeCtaAutomationService, initializeCtaStoreListener } from './packages/cta-automation';
import { initializePriceAutomationService } from './packages/price-automation';

export { loadCtaConfiguration } from './packages/cta-automation';
export { loadPriceData } from './packages/price-automation';

initializeCtaAutomationService();
initializePriceAutomationService();
const tempConfigurationId: any = '';
initializeCtaStoreListener(tempConfigurationId);
